/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DistrictResource } from './districtResource';


export interface MunicipalityResource { 
    /**
     * The code of the municipality.
     */
    code: string;
    /**
     * The code of the district.
     */
    districtCode: string;
    /**
     * The name of the municipality.
     */
    name: string;
    /**
     * The short name of the municipality.
     */
    shortName: string;
    /**
     * The status of the municipality.
     */
    isActive: boolean;
    /**
     * The date when the municipality was established.
     */
    establishedDate: string;
    /**
     * The note about the establishment of the municipality.
     */
    establishedNote: string | null;
    /**
     * The date when the municipality was terminated.
     */
    terminatedDate: string | null;
    /**
     * The note about the termination of the municipality.
     */
    terminatedNote: string | null;
    /**
     * The NUTS5 code of the municipality.
     */
    nuts5: string;
    /**
     * The authorized municipality code.
     */
    authorizedMunicipalityCode: string;
    /**
     * The district of the municipality.
     */
    district?: DistrictResource;
}

